<atlas-panel-header>
  <div header i18n="@@reportsPanelHeader">Reports panel</div>
  <div description i18n="@@swipeRightDescription">
    Swipe right to access the Properties panel
  </div>
</atlas-panel-header>

@if (isSMFeatureSelected$ | async) {
  <atlas-spatial-modeller-reports
  ></atlas-spatial-modeller-reports>
}

@if (isLocatorFeatureSelected$ | async) {
  <atlas-locator-reports
  ></atlas-locator-reports>
}

@if (
  (isProfilerFeatureSelected$ | async) &&
  (profilerStatus$ | async) === 'ReportAggregateCompleted'
  ) {
  <atlas-profiler-reports
  ></atlas-profiler-reports>
}
